import useSWRImmutable from 'swr/immutable';
import CruiseService from '@/services/TourServices/CruiseService';

const useCruiseInclusionsExclusions = () => useSWRImmutable(
    'cruise-inclusions-exclusions',
    CruiseService.getInclusionsExclusions,
);

export default useCruiseInclusionsExclusions;
